import * as URL from "../configs/APIUrl";
import privateAPI from "../rest_handlers/privateAPI";
import {getBranchId} from "../helpers/Utils";

export default class ReadyProductStockTransactionService {

    static createStockTransaction = data => privateAPI.post(
        `${URL.READY_PRODUCT_CREATE_STOCK_TRANSACTION_URL}/${getBranchId()}`, data
    );

    static stockTransactionOut = data => privateAPI.post(
        `${URL.READY_PRODUCT_STOCK_TRANSACTION_OUT_URL}/${getBranchId()}`, data
    );

    static updateStockTransactionOut = (id, data) => privateAPI.put(
        `${URL.READY_PRODUCT_UPDATE_STOCK_TRANSACTION_OUT_URL}/${id}/${getBranchId()}`, data
    );

    static getAllStockTransaction = params => privateAPI.get(
        `${URL.READY_PRODUCT_GET_ALL_STOCK_TRANSACTION_URL}/${getBranchId()}`, {
            params,
            paramsSerializer: {
                indexes: null // by default: false
            }
        }
    );

    static getStockTransactionById = id => privateAPI.get(`${URL.READY_PRODUCT_GET_STOCK_TRANSACTION_BY_ID_URL}/${id}/${getBranchId()}`);

    static updateStockTransactionIn = (id, data) => privateAPI.put(
        `${URL.READY_PRODUCT_UPDATE_STOCK_TRANSACTION_IN_URL}/${id}/${getBranchId()}`,
        data
    );

    static getStockTransactionsByIngredientId = params => privateAPI.get(
        `${URL.READY_PRODUCT_GET_STOCK_TRANSACTION_BY_INGREDIENT_ID}/${getBranchId()}`,
        {params}
    );

    static adjustMultipleStockTransaction = data => privateAPI.put(
        `${URL.READY_PRODUCT_ADJUST_MULTIPLE_STOCK_TRANSACTION_PAYMENT}/${getBranchId()}`, data
    );

    static createProductStockTransaction = data => privateAPI.post(
        `${URL.READY_PRODUCT_CREATE_PRODUCT_STOCK_TRANSACTION_URL}/${getBranchId()}`, data
    );

    static cancelStockTransactionIn = (id, data) => privateAPI.put(
        `${URL.READY_PRODUCT_CANCEL_STOCK_TRANSACTION_URL}/${id}/${getBranchId()}`,
        data
    );

}
